<template>
  <ResourceView :entityId="$route.params.contractId" entityClass="Contract">
  </ResourceView>
</template>


<script>
import ResourceView from "@/views/admin/machines/ResourceView.vue";

export default {
  name: "ViewContractResources",
  components: {
    ResourceView,
  },

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style scoped></style>